import React from 'react'
import { UsersHomeForm } from '../components/Users/UsersHomeForm'
import '../css/Register.css';

export const UsersHomePage = () => {
    return <UsersHomeForm />
   
}